import React from 'react';
import ScheduledEmailItem from '../_scheduled-email-item/scheduled-email-item';
import DefaultButton from '../../../../../../global/default-button/default-button';
import { useIntl } from 'react-intl';
import { ADD_SCHEDULED_EMAIL_TEXT } from '../scheduled-emails-form.texts';
import { capitalizeFirstLetter } from '../../../../../../../infrastructure/utils/string.utils';
import { ScheduledMeetingEmailPopup } from '../_new-scheduled-meeting-email-popup/scheduled-meeting-email-popup-presentation';
import { ScheduledEventEmailsVM } from '../_scheduled-events-emails-form.viewmodel';
import { ScheduledMeetingsEmailsVM } from '../_scheduled-meeting-emails-form.viewmodel';
import { observer } from 'mobx-react';
import { IScheduledEmailDTO, ScheduledEmailSentStatus, ScheduledEmailSentStatusLabel, ScheduledTypes } from '../../../../../../../api/scheduled-email.dao';
import { ScheduledEmailsFormManagement } from '../scheduled-emails-form-management.viewmodel';

interface IProps {
    vm: ScheduledEmailsFormManagement;
}

type EmailGroupItem = {
    type: ScheduledTypes;
    status: ScheduledEmailSentStatus;
    emails: IScheduledEmailDTO[];
    viewModel: ScheduledEventEmailsVM | ScheduledMeetingsEmailsVM;
};

const ScheduledEmailsFormSection = observer((props: IProps) => {
    const { vm } = props;
    const sortedEmails: EmailGroupItem[] = vm.getSortedEmailGroups();
    const intl = useIntl();

    return (
        <>
            {sortedEmails.map((item, i) => {
                const {
                    onCreateAction,
                    removeScheduledEmail,
                    onEditAction,
                    isEmailEditFormShown,
                } = item.viewModel;

                const timeZone = item.viewModel.getEvent().timeZone;

                return (
                    <div className='scheduled-emails-form-section' key={i}>
                        <div className='scheduled-emails-form-section__title'>
                            <p>
                                {item.status === ScheduledEmailSentStatus.Other
                                    ? ScheduledEmailSentStatusLabel.Scheduled
                                    : ScheduledEmailSentStatusLabel.Sent
                                } {capitalizeFirstLetter(item.type)} Emails
                            </p>
                            {item.status === ScheduledEmailSentStatus.Other && (
                                <DefaultButton
                                    text={intl.formatMessage(ADD_SCHEDULED_EMAIL_TEXT)}
                                    modifier='lite'
                                    onClick={onCreateAction}
                                />
                            )}
                        </div>

                        {!!item.emails.length && (
                            <div className='scheduled-emails-form__list'>
                                {item.emails.map(email => (
                                    <ScheduledEmailItem
                                        key={email.id}
                                        email={email}
                                        timeZone={timeZone}
                                        onRemove={removeScheduledEmail}
                                        onEdit={onEditAction}
                                        isSelected={isEmailEditFormShown(email.id)}
                                        type={item.type}
                                    />
                                ))}
                            </div>
                        )}

                        <ScheduledMeetingEmailPopup
                            vm={(item.viewModel as ScheduledMeetingsEmailsVM).scheduledMeetingPopupVM}
                        />
                    </div>
                );
            })}
        </>
    );
});

export { ScheduledEmailsFormSection };